import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import WarningAlertIcon from "../../../assets/images/icons/WarningAlertIcon.tsx";
import styles from "./ErrorAlertWithCode.module.scss";

type ErrorAlertWithCodeProps = {
	open: boolean;
	title?: string;
	code?: string | number;
	message?: string;
	onClose?: () => void;
	autoHideDurationMs?: number;
};

const ErrorAlertWithCode = ({ open, title, code, message, onClose, autoHideDurationMs }: ErrorAlertWithCodeProps) => {
	const { t } = useTranslation("translation", { keyPrefix: "errorAlertWithCode" });

	useEffect(() => {
		if (!open || !autoHideDurationMs) return;
		const timer = setTimeout(() => onClose?.(), autoHideDurationMs);
		return () => clearTimeout(timer);
	}, [open, autoHideDurationMs, onClose]);

	if (!open) return null;

	return (
		<div className={styles.container} role="alert" aria-live="assertive">
			<div className={styles.headerRow}>
				<WarningAlertIcon height={24} width={24} primaryColor={"#dc3545"} />
				<Typography className={styles.title} component="div">
					{title || t("title")}
				</Typography>
				<button aria-label={t("close")} className={styles.closeButton} onClick={onClose}>
					<CloseIcon fontSize="small" />
				</button>
			</div>
			<div className={styles.content}>
				{code !== undefined && code !== null && (
					<div className={styles.row}>
						<span className={styles.label}>{t("errorCodeLabel")}:</span>
						<span className={styles.value}>#{code}</span>
					</div>
				)}
				{message && (
					<div className={styles.row}>
						<span className={styles.label}>{t("messageLabel")}:</span>
						<span className={styles.value}>{message}</span>
					</div>
				)}
			</div>
		</div>
	);
};

export default ErrorAlertWithCode;
